const Course = () => import('@/views/main/fubo/course/Course.vue')
export default {
  path: '/main/fubo/course',
  name: 'Course',
  component: Course,
  children: []
}
